import { useState } from 'react';
import HeroBanner from '../Components/SplashPage/HeroBanner';
import FloatingHeader from '../Components/PageWide/FloatingHeader';
import Footer from '../Components/PageWide/Footer';
import { useLocation } from 'react-router-dom';
import UsePageTitle from '../Controls/UsePageTitle';

// 1. PageLayout must now accept currentPage and setCurrentPage as props.
export default function PageLayout({ children, currentPage, setCurrentPage }) {
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  const [heroHeight, setHeroHeight] = useState(0);

  return (
    <>
      <UsePageTitle />
      {isHome && <HeroBanner setHeroHeight={setHeroHeight} />}
      
      {/* 2. Pass currentPage and setCurrentPage down to FloatingHeader. */}
      <FloatingHeader 
        showImmediately={!isHome} 
        heroHeight={heroHeight} 
        currentPage={currentPage}
        setCurrentPage={setCurrentPage} 
      />
      
      <main className="container">{children}</main>
      <Footer />
    </>
  );
}